import { render, staticRenderFns } from "./GoodsPriceUpdate.vue?vue&type=template&id=63d1b7d0&"
import script from "./GoodsPriceUpdate.vue?vue&type=script&lang=js&"
export * from "./GoodsPriceUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports